// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"styles_privacyPolicy__1iN7b"};